import { Extension } from '@tiptap/core'
import { PluginKey } from '@tiptap/pm/state'
import Suggestion from '@tiptap/suggestion'
import { getIssueSuggestionPopup } from '../components/IssueSuggestionPopup'
import { IssueRef } from './issue-reference'

export interface IssueSuggestionItem {
  id: number
  label: string
}

interface Options {
  url: string
}

export const IssueSuggestion = Extension.create<Options>({
  name: 'issueSuggestion',

  addOptions() {
    return { url: '' }
  },

  addProseMirrorPlugins() {
    const baseUrl = this.options.url
    let abortCtrl: AbortController | undefined

    return [
      Suggestion({
        pluginKey: new PluginKey(IssueRef.name),
        editor: this.editor,
        char: '#',
        allowSpaces: false,

        items: async ({ query }) => {
          abortCtrl?.abort()
          const ctrl = new AbortController()
          abortCtrl = ctrl
          try {
            const res = await fetch(
              baseUrl + encodeURIComponent(query),
              { signal: ctrl.signal },
            )
            if (!res.ok)
              return []
            return res.json() as Promise<IssueSuggestionItem[]>
          }
          catch {
            return []
          }
          finally {
            if (abortCtrl === ctrl)
              abortCtrl = undefined
          }
        },

        command: ({ editor, range, props }) => {
          const item = props as IssueSuggestionItem
          const raw = `#${item.id}`
          editor.chain().deleteRange(range).insertContentAt(range, [
            { type: IssueRef.name, attrs: { issueId: String(item.id), title: item.label, raw } },
          ]).run()
        },

        render: () => ({
          onStart(props) {
            getIssueSuggestionPopup()?.show(props.items, props.clientRect!, props.command)
          },
          onUpdate(props) {
            getIssueSuggestionPopup()?.update(props.items, props.clientRect!)
          },
          onKeyDown({ event }) {
            return getIssueSuggestionPopup()?.handleKeyDown(event) ?? false
          },
          onExit() {
            getIssueSuggestionPopup()?.hide()
          },
        }),
      }),
    ]
  },
})
